import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const CollectionMethodChartsDataContext = createContext();

const CollectionMethodChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.COLLECTION_METHOD_MAPPING,
            url: 'governanceroom/dashboard/unifiedregistry/mapping/collection-method'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              familiesPerEstablishmentSocialHealth: data?.familiesPerEstablishmentSocialHealth ?? [],
              familiesPerEstablishmentSocialAssistance: data?.familiesPerEstablishmentSocialAssistance ?? [],
              familiesPerLocality: data?.familiesPerLocality ?? [],
              familiesPerSocialSector: data?.familiesPerSocialSector ?? []
          }
        : {
              familiesPerEstablishmentSocialHealth: [],
              familiesPerEstablishmentSocialAssistance: [],
              familiesPerLocality: [],
              familiesPerSocialSector: []
          };

 

    return (
        <CollectionMethodChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </CollectionMethodChartsDataContext.Provider>
    );
};

export default CollectionMethodChartsDataProvider;
